import axios from "axios";
import React, { useState } from "react";
import { apiKey } from "../../../config/config";
import { toast } from "react-toastify";

function ProfilePage() {
  const customer = JSON.parse(localStorage.getItem("rms-customer"));
  const [formData, setFormData] = useState({
    name: customer?.customer.name,
    phone: customer?.customer.phone,
    email: customer?.customer.email,
  });
  const [passwordData, setPasswordData] = useState({
    current_password: "",
    password: "",
    password_confirmation: "",
  });
  const [profileLoading, setProfileLoading] = useState(false);
  const [passwordLoading, setPasswordLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handlePasswordChange = (e) => {
    setPasswordData({
      ...passwordData,
      [e.target.name]: e.target.value,
    });
  };

  const handleProfileUpdate = (e) => {
    e.preventDefault();

    setProfileLoading(true);

    axios
      .put(`${apiKey}/api/rms/customer/update-profile`, formData, {
        headers: {
          Authorization: `Bearer ${customer?.token}`,
        },
      })
      .then((res) => {
        toast.success("Success", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      })
      .catch((err) => {
        toast.error(err.response.data.message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      })
      .finally(() => setProfileLoading(false));
  };

  const handlePasswordUpdate = (e) => {
    e.preventDefault();

    setPasswordLoading(true);

    axios
      .put(`${apiKey}/api/rms/customer/update-password`, passwordData, {
        headers: {
          Authorization: `Bearer ${customer?.token}`,
        },
      })
      .then((res) => {
        toast.success("Success", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      })
      .catch((err) => {
        toast.error(err.response.data.message, {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      })
      .finally(() => setPasswordLoading(false));
  };

  return (
    <div className="grid place-items-center w-full">
      <div className="w-full m-3 p-4 space-y-4">
        <form onSubmit={handleProfileUpdate} action="">
          <h2 className="text-3xl py-2 px-3 text-w-heading">Profile Details</h2>
          <div className="grid grid-cols-2 gap-4 w-full">
            <input
              className="border h-9 rounded w-full px-2"
              placeholder="Name"
              type="text"
              name="name"
              id=""
              value={formData.name}
              onChange={handleChange}
            />
            <input
              className="border h-9 rounded w-full px-2"
              placeholder="Phone"
              type="text"
              name="phone"
              id=""
              value={formData.phone}
              onChange={handleChange}
            />
            <input
              className="border h-9 rounded w-full px-2"
              type="text"
              placeholder="Email"
              name="email"
              id=""
              value={formData.email}
              onChange={handleChange}
              disabled
            />
          </div>

          <button
            className="bg-w-btn rounded text-center p-1 text-w-btn-text flex justify-center items-center gap-2 my-4 max-w-[8rem] w-full relative"
            type="submit"
          >
            {profileLoading && (
              <span className="absolute top-0 left-0 w-full h-full py-1 px-3 bg-black bg-opacity-50">
                <img
                  className="w-4 mx-auto"
                  src="/assets/gif/button_loader.gif"
                  alt=""
                />
              </span>
            )}
            <span>Update</span>
          </button>
        </form>
        <hr />
        <form action="" onSubmit={handlePasswordUpdate}>
          <h2 className="text-3xl py-2 px-3 text-w-heading">Password Update</h2>
          <div className="grid grid-cols-2 gap-4 w-full">
            <input
              className="border h-9 rounded w-full px-2"
              placeholder="Current Password"
              type="password"
              name="current_password"
              id=""
              value={passwordData.current_password}
              onChange={handlePasswordChange}
            />
            <input
              className="border h-9 rounded w-full px-2"
              placeholder="New Password"
              type="password"
              name="password"
              id=""
              value={passwordData.password}
              onChange={handlePasswordChange}
            />
            <input
              className="border h-9 rounded w-full px-2"
              placeholder="Confirm Password"
              type="password"
              name="password_confirmation"
              id=""
              value={passwordData.password_confirmation}
              onChange={handlePasswordChange}
            />
          </div>

          <button className="bg-w-btn rounded text-center p-1 text-w-btn-text flex justify-center items-center gap-2 my-4 max-w-[8rem] w-full relative">
            {passwordLoading && (
              <span className="absolute top-0 left-0 w-full h-full py-1 px-3 bg-black bg-opacity-50">
                <img
                  className="w-4 mx-auto"
                  src="/assets/gif/button_loader.gif"
                  alt=""
                />
              </span>
            )}
            <span>Update</span>
          </button>
        </form>
      </div>
    </div>
  );
}

export default ProfilePage;
